import {CustomWiggle} from "gsap/dist/CustomWiggle";
import {Linear} from "gsap";

/**
 * Created by Jerker Nord on 2021-04-30.
 */

export class TheBorderStatics {

    public static defaultGameAreaSize:number[] = [6, 6, 6, 6, 6, 6];
    public static symbolWidth:number = 120;
    public static symbolHeight:number = 100;
    public static TOTAL_WIN_VIEW_POSITION:PIXI.Point = new PIXI.Point(0, 0);

    //The amount of time the collapse reels animation should overlap the win animation
    public static COLLAPSE_OVERLAP:number = 0.4;

    //The delay before next XSplit animation starts (if there is more than one)
    public static X_SPLIT_OVERLAP:number = 0;

    //All in total spin time
    public static mainAllInTotalSpinDuration:number = 0.36;
    public static mainAllInTotalSpinDurationFastSpin:number = 0.28;

    //Delay between reels, all in
    public static mainReelAllInStopDelay:number = 0.18;
    public static mainReelAllInStopDelayFastSpin:number = 0.07;

    //Blur delay, all in
    public static mainReelAllInBlurDelay:number = 0.31;
    public static mainReelAllInBlurDelayFastSpin:number = 0.28;

    //Spin-in gap between symbols
    public static mainReelSpinStopSymbolDelay:number = 0;
    public static mainReelSpinStopSymbolDelayFastSpin:number = 0;

    //All in reel spin acceleration
    public static mainAllInReelAcceleration:number = 0.05;
    public static mainAllInReelAccelerationFastSpin:number = 0.05;


    //All out total spin time
    public static mainReelAllOutTotalSpinDuration:number = 0.25;
    public static mainReelAllOutTotalSpinDurationFastSpin:number = 0.15;

    //Delay between reels, all out
    public static mainReelAllOutStopDelay:number = 0.04;
    public static mainReelAllOutStopDelayFastSpin:number = 0.03;

    //Spin-out gap between symbols
    public static mainReelSpinStartSymbolDelay:number = 0;

    //Blur delay, all out
    public static mainReelAllOutBlurDelay:number = 0;
    public static mainReelAllOutBlurDelayFastSpin:number = 0;

    public static reelPositions:PIXI.Point[] = [
        new PIXI.Point(TheBorderStatics.symbolWidth * 0, 0),
        new PIXI.Point(TheBorderStatics.symbolWidth * 1, 0),
        new PIXI.Point(TheBorderStatics.symbolWidth * 2, 0),
        new PIXI.Point(TheBorderStatics.symbolWidth * 3, 0),
        new PIXI.Point(TheBorderStatics.symbolWidth * 4, 0),
        new PIXI.Point(TheBorderStatics.symbolWidth * 5, 0)
    ];
    public static PORTRAIT_Y_OFFSET:number = 360;
    public static MAIN_REELS_VIEW_POSITION:PIXI.Point = new PIXI.Point(59, 142);
    public static MAIN_REELS_VIEW_MASK_POSITION:PIXI.Point = new PIXI.Point(-60, -50);

    //Easing
    public static bombShakeWiggleX = CustomWiggle.create("bombShakeWiggleX", {
        wiggles:4,
        amplitudeEase:Linear.easeNone,
        timingEase:Linear.easeNone,
    });

    public static bombShakeWiggleY = CustomWiggle.create("bombShakeWiggleY", {
        wiggles:2,
        amplitudeEase:Linear.easeNone,
        timingEase:Linear.easeNone,
    });

    public static reelLandingShake = CustomWiggle.create("reelLandingShake", {
        wiggles:1,
        type:"easeOut"
    });

    public static bigWinAnticipationWiggle = CustomWiggle.create("bigWinAnticipationWiggle", {
        wiggles:50,
        amplitudeEase:Linear.easeNone,
        timingEase:Linear.easeNone,
    });
    public static bigWinAnticipationWiggle2 = CustomWiggle.create("bigWinAnticipationWiggle", {
        wiggles:40,
        amplitudeEase:Linear.easeNone,
        timingEase:Linear.easeNone,
    });

    public static m0Hit100Wiggle = CustomWiggle.create("m0HitWiggle", {
        wiggles: 60,
        amplitudeEase: Linear.easeNone,
        timingEase: Linear.easeNone,
    });
    public static m0Hit500Wiggle = CustomWiggle.create("m0HitWiggle", {
        wiggles: 50,
        amplitudeEase: Linear.easeNone,
        timingEase: Linear.easeNone,
    });
    public static m0HitMoreThan500Wiggle = CustomWiggle.create("m0HitWiggle", {
        wiggles: 40,
        amplitudeEase: Linear.easeNone,
        timingEase: Linear.easeNone,
    });
}